let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("i1yZZ")).then(() => parcelRequire('3uAOF'));